import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PageViewState {
    isSinglePage: boolean;
}
interface PageViewPayload {
    isSinglePage: boolean;
}
const initialState: PageViewState = {
    isSinglePage: false,
};

const pageViewSlice = createSlice({
    name: 'pageView',
    initialState,
    reducers: {
        setIsSinglePage: (state, action: PayloadAction<PageViewPayload>) => {
            state.isSinglePage = action.payload.isSinglePage;
        },
    },
});

export const { setIsSinglePage } = pageViewSlice.actions;
export default pageViewSlice.reducer;
